import api from 'api'

export type DeleteCushionChargePolicyRequest = {
  companyId: number
  policyId: number
}

export const deleteCushionChargePolicy = async ({
  companyId,
  policyId,
}: DeleteCushionChargePolicyRequest): Promise<void> => {
  await api.delete(
    `/admin/company/${companyId}/cushion_charge_policies/${policyId}`
  )
}
